theme = {
  strings: {
    calculatorResultsTitle1: "a besoin de ",
    calculatorResultsTitle2: "<strong>Kcal/jour</strong>, soit",
  },
};

const Calculator = {
  init: function () {
    this.forceOpen();
    this.calculatorView();
  },

  forceOpen: function () {
    if (
      window.location.hash === "#calculator" &&
      $("[data-product-calculator]").length
    ) {
      $(window).on("load", function () {
        $("[data-product-calculator]").trigger("click");
      });
    }
  },

  calculatorView: function () {
    if ($("section--calculate-dog") || $("section--calculate-cat")) {
      Calculator.form();
    }
  },

  handleRange: function (calculator, value) {
    let text = "";
    let manageLeft = 7;
    value = parseInt(value);
    switch (value) {
      case 0:
        text = "100/0";
        manageLeft = 4;
        break;
      case 25:
        text = "75/25";
        manageLeft = 5;
        break;
      case 50:
        text = "50/50";
        break;
      case 75:
        text = "25/75";
        manageLeft = 8;
        break;
      case 100:
        text = "0/100";
        manageLeft = 10;
        break;
    }
    let outputRange = calculator.find(".output-range");
    let marginLeftValue = value - manageLeft;
    outputRange.css("left", `${marginLeftValue}%`);
    outputRange.text(`${text}`);
  },

  displayFlavour: function (inputFlavours, flavourToDisplay) {
    inputFlavours.each((i, flavour) => {
      if ($(flavour).attr("data-type") === flavourToDisplay) {
        $(flavour).removeClass("hidden");
        $(flavour)
          .find("li:first-child input[name=second_product]")
          .prop("checked", true);
      } else {
        $(flavour).addClass("hidden");
        $(flavour)
          .find("li input[name=second_product]:checked")
          .prop("checked", false);
      }
    });
  },

  convertMainProductIntoArray: function (listVariantsOption) {
    let mainProductVariants = {};
    listVariantsOption.each(function () {
      const value = $(this).val();
      let label = $(this).text().trim();
      let price = $(this).attr("data-variant-price-selling-plan");
      let qty_per_unit = 1;
      let selling_plan = $(this).attr("data-variant-selling-plan");
      let qtyAvailable = $(this).attr("data-variant-qty-available");
      let productType = $(this).attr("data-variant-product-type");
      let productAvailable = $(this).attr("data-variant-available");
      productAvailable = JSON.parse(productAvailable);

      selling_plan = JSON.parse(selling_plan);

      let convertedValue;
      let unit;

      if (label.includes("kg")) {
        let numericValue = parseFloat(label.replace("kg", "").trim());
        convertedValue = numericValue * 1000;
        unit = "g";
      } else if (label.includes("g")) {
        let parts = label.split("x");
        qty_per_unit = parseInt(parts[0]);
        convertedValue = parseFloat(parts[1].replace("g", "").trim());
        unit = "g";
      } else {
        convertedValue = label;
        unit = "unit";
      }

      mainProductVariants[value] = {
        weight: convertedValue,
        qty_per_unit: qty_per_unit,
        unit: unit,
        price: price,
        selling_plan: selling_plan,
        qty_available: qtyAvailable,
        product_type: productType,
        product_available: productAvailable,
      };
    });
    return mainProductVariants;
  },

  convertSecondProductIntoArray: function (
    idArray,
    priceArray,
    qtyArray,
    productType,
    listSellingPlan,
    listQtyAvailable,
    listAvailable
  ) {
    let secondProductVariants = {};
    $.each(idArray, function (index, value_item) {
      const value = value_item;
      let label = qtyArray[index];
      let price = priceArray[index];
      let qty_per_unit = 1;
      let selling_plan = listSellingPlan;
      let qtyAvailable = listQtyAvailable[index];
      let productAvailable = JSON.parse(listAvailable[index]);

      let convertedValue;
      let unit;

      if (typeof label.weight === "string") {
        let numericValue;
        if (label.weight.includes("kg")) {
          numericValue = parseFloat(label.weight.replace("kg", "").trim());
          convertedValue = numericValue * 1000;
          unit = "g";
        } else if (label.weight.includes("g")) {
          qty_per_unit = label.quantity || 1;
          numericValue = parseFloat(label.weight.replace("g", "").trim());
          convertedValue = numericValue;
          unit = "g";
        } else {
          qty_per_unit = label.quantity || 1;
          convertedValue = label.weight;
          unit = "unit";
        }
      } else {
        qty_per_unit = Number(label.quantity);
        if (label.weight != null) {
          convertedValue = Number(label.weight.replace("g", ""));
        } else {
          convertedValue = 1;
          throw new Error("weight is null");
        }
        unit = "g";
      }

      secondProductVariants[value] = {
        weight: convertedValue,
        qty_per_unit: qty_per_unit,
        unit: unit,
        price: price,
        selling_plan: selling_plan,
        qty_available: qtyAvailable,
        product_type: productType,
        product_available: productAvailable,
      };
    });
    return secondProductVariants;
  },

  convertWordingGtoKg: function (qtyValue) {
    return parseFloat(qtyValue / 1000).toFixed(0) + "kg";
  },

  convertProductTypeToWording: function (productType, has_pronoun = false) {
    let productHumidWording;

    if (has_pronoun) {
      if (productType === "croquettes") {
        productHumidWording = "de croquettes";
      } else if (productType === "patees") {
        productHumidWording = "de pâtées";
      } else if (productType === "effiles") {
        productHumidWording = "d'effilés";
      } else if (productType === "eminces") {
        productHumidWording = "d'émincés";
      }
    } else {
      if (productType === "croquettes" || productType === "croquette") {
        productHumidWording = "croquettes";
      } else if (productType === "patees" || productType === "patee") {
        productHumidWording = "pâtées";
      } else if (productType === "effiles" || productType === "effile") {
        productHumidWording = "effilés";
      } else if (productType === "eminces" || productType === "emince") {
        productHumidWording = "émincés";
      }
    }

    return productHumidWording;
  },

  updateCalculatorResults: function (
    $calculator,
    result,
    theme,
    regimeType,
    kcalTitle,
    mainOptimalVariant,
    secondOptimalVariant,
    croquetteWeight,
    humidWeight,
    atcBiNutrition
  ) {
    Calculator.handleAtcButton(
      $calculator,
      mainOptimalVariant,
      secondOptimalVariant
    );
    Calculator.showHideRegimeType(regimeType, croquetteWeight, humidWeight);
    Calculator.updateCalculatorWeightResults(
      regimeType,
      croquetteWeight,
      humidWeight,
      secondOptimalVariant
    );
    Calculator.updateCalculatorQuantityResults(
      $calculator,
      result,
      theme,
      kcalTitle,
      mainOptimalVariant,
      secondOptimalVariant,
      croquetteWeight,
      humidWeight,
      atcBiNutrition
    );
  },

  updateCalculatorWeightResults: function (
    regimeType,
    croquetteWeight,
    humidWeight,
    secondOptimalVariant
  ) {
    let secondVariant = secondOptimalVariant
      ? Object.values(secondOptimalVariant)[0]
      : null;
    let secondProductType = secondVariant
      ? secondVariant.product_type
      : "patees";
    let wordingHumid = Calculator.convertProductTypeToWording(
      secondProductType,
      true
    );

    if (humidWeight > 0 && croquetteWeight > 0) {
      regimeType
        .find("[regime-type-croquette-wording]")
        .html("de croquettes +");
    } else {
      regimeType.find("[regime-type-croquette-wording]").html("de croquettes");
    }
    regimeType.find("[regime-type-hummid-wording]").html(`${wordingHumid}`);
    regimeType.find("[regime-type-value-croquette]").html(croquetteWeight);
    regimeType.find("[regime-type-value-humid]").html(humidWeight);
  },

  updateCalculatorQuantityResults: function (
    $calculator,
    result,
    theme,
    kcalTitle,
    mainOptimalVariant,
    secondOptimalVariant,
    croquetteWeight,
    humidWeight,
    atcBiNutrition
  ) {
    let mainVariant = mainOptimalVariant
      ? Object.values(mainOptimalVariant)[0]
      : null;
    let secondVariant = secondOptimalVariant
      ? Object.values(secondOptimalVariant)[0]
      : null;

    let mainProductQty = mainVariant
      ? mainVariant.weight * mainVariant.qty_per_unit
      : null;
    let mainProductTotalQty = mainVariant ? mainVariant.total_quantity : null;

    let secondProductQty = secondVariant
      ? secondVariant.weight * secondVariant.qty_per_unit
      : null;
    let secondProductTotalQty = secondVariant
      ? secondVariant.total_quantity
      : null;
    let secondProductType = secondVariant
      ? secondVariant.product_type
      : "pâtées";

    let wordingQuantity = "";
    let croquetteText = "";
    let pateeText = "";

    let productHumidWording =
      Calculator.convertProductTypeToWording(secondProductType);

    if (croquetteWeight > 0) {
      if (mainProductTotalQty > 1) {
        croquetteText =
          "<strong>" +
          "(" +
          mainProductTotalQty +
          ")x" +
          Calculator.convertWordingGtoKg(mainProductQty) +
          " de croquettes </strong>";
      } else {
        croquetteText =
          "<strong>" +
          Calculator.convertWordingGtoKg(mainProductQty) +
          " de croquettes </strong>";
      }
    }

    if (humidWeight > 0) {
      pateeText =
        "<strong>" +
        secondProductTotalQty * secondVariant.qty_per_unit +
        " " +
        productHumidWording +
        " de " +
        secondVariant.weight +
        "g</strong> soit " +
        secondProductTotalQty +
        " lot de " +
        secondVariant.qty_per_unit;
    }

    if (croquetteWeight > 0 && humidWeight > 0) {
      wordingQuantity = croquetteText + "<br>+ " + pateeText;
    } else {
      wordingQuantity = croquetteText + pateeText;
    }

    let totalCents =
      (mainVariant?.total_price || 0) + (secondVariant?.total_price || 0);
    let price_atc = (Math.round(totalCents) / 100).toFixed(2) + "€";

    $(".product-proportion .product-quantity-product").html(wordingQuantity);
    atcBiNutrition.find(".price").html(price_atc);

    kcalTitle.html(
      theme.strings.calculatorResultsTitle1 +
        "<strong>" +
        Math.round(result) +
        "</strong>" +
        theme.strings.calculatorResultsTitle2
    );

    $calculator.find(".shutter__calculator-results").removeClass("hidden");
    $calculator.find(".image-empty-form").addClass("hidden");
  },

  showHideRegimeType: function (regimeType, croquetteWeight, humidWeight) {
    humidWeight = Number(humidWeight);
    croquetteWeight = Number(croquetteWeight);
    regimeType.find('[regime-type="croquette"]').toggle(croquetteWeight > 0);
    regimeType.find('[regime-type="humid"]').toggle(humidWeight > 0);
  },

  findOptimalVariant: function (productVariants, totalQty) {
    let optimalCost = Infinity;
    let optimalVariantId = null;
    let optimalVariant = null;
    let quantity = null;
    let sellingPlan = null;
    let qtyAvailable = null;
    let notEnoughQty = false;
    let productType = null; // croquette, patee, effile, emmice
    let productAvailable = true;

    Object.entries(productVariants).forEach(([id, variant]) => {
      const requiredQty = Math.ceil(
        totalQty / (variant.weight * variant.qty_per_unit)
      );
      const totalCost = requiredQty * variant.price;

      if (totalCost < optimalCost) {
        optimalCost = totalCost;
        optimalVariantId = id;
        optimalVariant = variant;
        quantity = requiredQty;
        sellingPlan = variant.selling_plan;
        qtyAvailable = variant.qty_available;
        productType = variant.product_type;
        productAvailable = JSON.parse(variant.product_available);
        if (requiredQty > qtyAvailable) {
          notEnoughQty = true; // La quantité est suffisante pour cette variante
        }
      }
    });

    if (notEnoughQty) {
      // Rechercher une autre variante avec une quantité suffisante
      for (let [id, variant] of Object.entries(productVariants)) {
        const requiredQty = Math.ceil(
          totalQty / (variant.weight * variant.qty_per_unit)
        );
        if (requiredQty <= variant.qty_available) {
          optimalCost = requiredQty * variant.price;
          optimalVariantId = id;
          optimalVariant = variant;
          quantity = requiredQty;
          sellingPlan = variant.selling_plan;
          qtyAvailable = variant.qty_available;
          notEnoughQty = false;
          productType = variant.product_type;
          productAvailable = JSON.parse(variant.product_available);
          break;
        }
      }
    }

    return {
      [optimalVariantId]: {
        ...optimalVariant,
        total_price: optimalCost,
        total_quantity: quantity,
        selling_plan: sellingPlan,
        qty_available: qtyAvailable,
        not_enough_qty: notEnoughQty,
        product_type: productType,
        product_available: productAvailable,
      },
    };
  },

  calculateWeightsProportion(
    animalRegime,
    result,
    productDryCalories,
    productHumidCalories
  ) {
    let croquetteWeight = 0;
    let humidWeight = 0;

    switch (animalRegime) {
      case 0:
        croquetteWeight = Math.round((result / productDryCalories) * 100);
        break;
      case 25:
        croquetteWeight = Math.round((result / productDryCalories) * 75);
        humidWeight = Math.round((result / productHumidCalories) * 25);
        break;
      case 50:
        croquetteWeight = Math.round((result / productDryCalories) * 50);
        humidWeight = Math.round((result / productHumidCalories) * 50);
        break;
      case 75:
        croquetteWeight = Math.round((result / productDryCalories) * 25);
        humidWeight = Math.round((result / productHumidCalories) * 75);
        break;
      case 100:
        humidWeight = Math.round((result / productHumidCalories) * 100);
        break;
    }

    return { croquetteWeight, humidWeight };
  },

  handleAtcButton: function (
    calculator,
    mainOptimalVariant,
    secondOptimalVariant
  ) {
    let mainVariant = mainOptimalVariant
      ? Object.values(mainOptimalVariant)[0]
      : null;
    let secondVariant = secondOptimalVariant
      ? Object.values(secondOptimalVariant)[0]
      : null;

    let atcButton = calculator.find(".addtocart_bi-nutrition");

    let disableAtcButton = false;

    if (mainVariant) {
      if (
        mainVariant.product_available === false &&
        mainVariant.total_quantity !== 0
      ) {
        disableAtcButton = true;
      }
    }

    if (secondVariant) {
      if (
        secondVariant.product_available === false &&
        mainVariant.total_quantity !== 0
      ) {
        disableAtcButton = true;
      }
    }

    if (disableAtcButton) {
      atcButton.addClass("disable");
    } else {
      atcButton.removeClass("disable");
    }
  },

  addToCart: function (
    mainOptimalVariant,
    secondOptimalVariant,
    productSellingPlanIndex
  ) {
    let productId = mainOptimalVariant
      ? Object.keys(mainOptimalVariant)[0]
      : null;
    let secondProductId = secondOptimalVariant
      ? Object.keys(secondOptimalVariant)[0]
      : null;

    let productMainQty =
      mainOptimalVariant && mainOptimalVariant[productId]
        ? mainOptimalVariant[productId].total_quantity
        : null;
    let secondProductQty =
      secondOptimalVariant && secondOptimalVariant[secondProductId]
        ? secondOptimalVariant[secondProductId].total_quantity
        : null;

    let productSellingPlan =
      mainOptimalVariant &&
      mainOptimalVariant[Object.keys(mainOptimalVariant)[0]].selling_plan
        ? mainOptimalVariant[Object.keys(mainOptimalVariant)[0]].selling_plan[
            productSellingPlanIndex
          ]
        : null;
    let secondProductSellingPlanId =
      secondOptimalVariant &&
      secondOptimalVariant[Object.keys(secondOptimalVariant)[0]].selling_plan
        ? secondOptimalVariant[Object.keys(secondOptimalVariant)[0]]
            .selling_plan[productSellingPlanIndex]
        : null;

    let item_1 = {
      id: productId,
      quantity: productMainQty,
      selling_plan: productSellingPlan,
    };
    let item_2 = {
      id: secondProductId,
      quantity: secondProductQty,
      selling_plan: secondProductSellingPlanId,
    };
    let items = [];
    if (item_1.quantity === 0) {
      item_1 = null;
    }
    if (item_2.quantity === 0) {
      item_2 = null;
    }

    if (item_1 !== null) {
      items.push(item_1);
    }
    if (item_2 !== null) {
      items.push(item_2);
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => response.json())
      .then(() => {
        fetch(`${routes.cart_url}?section=cart-drawer,cart-icon-bubble`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            const selectors = ["#cart-icon-bubble", "cart-drawer"];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            document.querySelector("cart-drawer").classList.remove("is-empty");
            document.dispatchEvent(new CustomEvent("cart:open"));
          })
          .catch((e) => {
            console.error(e);
          });
      });
  },

  form: function () {
    var windowWidth = window.innerWidth;
    var isDesktop = windowWidth > 1000;

    $(".calculator-bi_nutrition").each(function () {
      var isMobileElement = $(this).attr("data-is-mobile") === "true";

      if ((isDesktop && isMobileElement) || (!isDesktop && !isMobileElement)) {
        $(this).remove();
      }
      var mainOptimalVariant = null;
      var secondOptimalVariant = null;
      var result = 0;
      var productFormat = 0;
      var animalWeight = 0;
      var animalBreed = 0;
      var animalBehavior = 0;
      var animalPhysiology = 0;
      var animalRegime = 0;
      var atcBiNutrition = null;
      var nickname = "Votre animal";
      var productType = "";

      const $calculator = $(this);
      const productShape =
        $calculator.find('input[name="product_shape"]').val() || "dry";

      animalRegime = $calculator.find('input[name="regime"]').val() || 100;
      animalRegime = parseInt(animalRegime);

      const mainProductVariantsOption = $("#calculate-product-select option");
      let mainProductVariants = {};
      mainProductVariants = Calculator.convertMainProductIntoArray(
        mainProductVariantsOption
      );

      const secondProductVariantsOption =
        $('input[name="second_product"]:checked') || null;
      let secondProductVariants = {};

      if (secondProductVariantsOption.length > 0) {
        const idArray =
          JSON.parse(secondProductVariantsOption.attr("data-variants-id")) ||
          [];
        const priceArray =
          JSON.parse(secondProductVariantsOption.attr("data-variants-price")) ||
          [];
        const productType =
          secondProductVariantsOption.attr("data-variants-foodtype") || [];
        let secondProductVariantsQtyAttr =
          secondProductVariantsOption.attr("data-variants-qty") || "";
        let secondProductVariantsQtySplit =
          secondProductVariantsQtyAttr.split(",") || [];
        const ArraysecondProductVariantsQty = [];
        $.each(secondProductVariantsQtySplit, function (index, pair) {
          var parts = pair.split("x");
          var quantity = parseInt(parts[0]);
          var weight = parts[1];
          ArraysecondProductVariantsQty.push({
            quantity: quantity,
            weight: weight,
          });
        });
        const qtyArray = ArraysecondProductVariantsQty;
        const listSellingPlan = JSON.parse(
          secondProductVariantsOption.attr(
            "data-product-selling_plan-subscription"
          )
        );
        const qtyAvailable = JSON.parse(
          secondProductVariantsOption.attr("data-variants-qty-available")
        );
        const listAvailable = JSON.parse(
          secondProductVariantsOption.attr("data-variants-available")
        );
        secondProductVariants = Calculator.convertSecondProductIntoArray(
          idArray,
          priceArray,
          qtyArray,
          productType,
          listSellingPlan,
          qtyAvailable,
          listAvailable
        );
      }

      $calculator.find(".addtocart_bi-nutrition").on("click", (e) => {
        e.preventDefault();
        let productSellingPlanIndex = $calculator
          .find('select[name="selling_plan"]')
          .prop("selectedIndex");
        Calculator.addToCart(
          mainOptimalVariant,
          secondOptimalVariant,
          productSellingPlanIndex
        );
      });

      $calculator
        .find('input[name="regime"]')
        .on("input touchmove", function (e) {
          const value = $(this).val();
          Calculator.handleRange($calculator, value);
        });

      $calculator.find("input, select").on("change", (changesElement) => {
        productType = $calculator.find('input[name="type"]').val() || "";
        nickname = $calculator.find('input[name="nickname"]').val() || "";
        productFormat = $calculator.find('input[name="format"]').val() || 0;
        animalWeight = $calculator.find('input[name="weight"]').val() || 0;
        animalBreed = $calculator.find('select[name="breed"]').val() || 0;
        animalBehavior = $calculator.find('select[name="behavior"]').val() || 0;
        animalPhysiology =
          $calculator.find('select[name="physiology"]').val() || 0;

        animalRegime = $calculator.find('input[name="regime"]').val() || 100;
        atcBiNutrition = $calculator.find(".addtocart_bi-nutrition");

        let inputFlavours = $calculator.find(".product__flavors");
        let flavourToDisplay = $calculator
          .find('.checkbox-food_type input[name="food_type"]:checked')
          .val();

        if ($(changesElement.target).is('input[name="food_type"]')) {
          Calculator.displayFlavour(inputFlavours, flavourToDisplay);
        }

        if ($calculator.find('input[name="height"]')) {
          let currentIndex = $calculator
            .find('input[name="height"]:checked')
            .attr("data-index");
          $calculator.find("[toggle-content-products-item]").addClass("hidden");
          $calculator
            .find(
              `[toggle-content-products-item][data-index="${currentIndex}"]`
            )
            .removeClass("hidden");
          $calculator
            .find(
              `[toggle-content-products-item][data-index="${currentIndex}"] input[type="radio"]`
            )
            .prop("checked", true);
        }

        let optionCurrentSellingPlan = $calculator.find(
          'select[name="selling_plan"] option:selected'
        );
        const frequencyPurshase =
          optionCurrentSellingPlan.attr("data-value-days");

        let productDryCalories;
        let productHumidCalories;
        if (productShape === "dry") {
          productDryCalories =
            $calculator.find('input[name="calories"]').val() || 0;
          productHumidCalories =
            $calculator
              .find('input[name="second_product"]:checked')
              .attr("data-calories-product") || 0;
        } else {
          productDryCalories =
            $calculator
              .find('input[name="second_product"]:checked')
              .attr("data-calories-product") || 0;
          productHumidCalories =
            $calculator.find('input[name="calories"]').val() || 0;
        }

        animalRegime = parseInt(animalRegime);
        animalWeight = parseFloat(animalWeight.replace(',', '.'));
        animalBreed = parseFloat(animalBreed);
        animalBehavior = parseFloat(animalBehavior);
        animalPhysiology = parseFloat(animalPhysiology);
        productDryCalories = parseFloat(productDryCalories);
        productHumidCalories = parseFloat(productHumidCalories);

        const coefficient =
          productType === "chien" || productType === "chiot"
            ? 156 * Math.pow(animalWeight, 0.67)
            : 60 * animalWeight;
        result = coefficient * animalBreed * animalBehavior * animalPhysiology;

        let enough_information = false;
        if (
          productType !== "" &&
          animalBehavior !== 0 &&
          productDryCalories !== 0 &&
          productHumidCalories !== 0 &&
          productFormat !== 0 &&
          animalWeight !== 0 &&
          animalBreed !== 0 &&
          animalPhysiology !== 0
        ) {
          enough_information = true;
        }

        if (nickname != "") {
          $calculator.find(".calculator-results-nickname").html(nickname);
          $calculator.find(".calculator-results-nickname-main").html(nickname);
          $calculator.find(".calculator-results-nickname-min").html(nickname);
          $calculator
            .find(".calculator-results-nickname-product")
            .html(nickname + "&nbsp;?");
          $calculator
            .find(".calculator-results-nickname-bi-nutrition")
            .html(nickname);
        } else {
          $calculator
            .find(".calculator-results-nickname")
            .html(
              $calculator
                .find(".calculator-results-nickname")
                .attr("data-default-nickname")
            );
          $calculator
            .find(".calculator-results-nickname-main")
            .html(
              $calculator
                .find(".calculator-results-nickname-main")
                .attr("data-default-nickname")
            );
          $calculator
            .find(".calculator-results-nickname-min")
            .html(
              $calculator
                .find(".calculator-results-nickname-min")
                .attr("data-default-nickname")
            );
          $calculator
            .find(".calculator-results-nickname-product")
            .html(
              $calculator
                .find(".calculator-results-nickname-product")
                .attr("data-default-nickname")
            );
          $calculator
            .find(".calculator-results-nickname-bi-nutrition")
            .html(
              $calculator
                .find(".calculator-results-nickname-bi-nutrition")
                .attr("data-default-nickname")
            );
        }

        const mainProductVariantsOption = $("#calculate-product-select option");
        let mainProductVariants = {};
        mainProductVariants = Calculator.convertMainProductIntoArray(
          mainProductVariantsOption
        );

        const secondProductVariantsOption =
          $('input[name="second_product"]:checked') || null;
        let secondProductVariants = {};

        if (secondProductVariantsOption.length > 0) {
          const idArray =
            JSON.parse(secondProductVariantsOption.attr("data-variants-id")) ||
            [];
          const priceArray =
            JSON.parse(
              secondProductVariantsOption.attr("data-variants-price")
            ) || [];
          const productType =
            secondProductVariantsOption.attr("data-variants-foodtype") || "";
          let secondProductVariantsQtyAttr =
            secondProductVariantsOption.attr("data-variants-qty") || "";
          let secondProductVariantsQtySplit =
            secondProductVariantsQtyAttr.split(",") || [];
          const ArraysecondProductVariantsQty = [];
          $.each(secondProductVariantsQtySplit, function (index, pair) {
            var parts = pair.split("x");
            var quantity = parseInt(parts[0]);
            var weight = parts[1] || 1;
            ArraysecondProductVariantsQty.push({
              quantity: quantity,
              weight: weight,
            });
          });
          const qtyArray = ArraysecondProductVariantsQty;
          const listSellingPlan = JSON.parse(
            secondProductVariantsOption.attr(
              "data-product-selling_plan-subscription"
            )
          );
          const qtyAvailable = JSON.parse(
            secondProductVariantsOption.attr("data-variants-qty-available")
          );
          const listAvailable = JSON.parse(
            secondProductVariantsOption.attr("data-variants-available")
          );
          secondProductVariants = Calculator.convertSecondProductIntoArray(
            idArray,
            priceArray,
            qtyArray,
            productType,
            listSellingPlan,
            qtyAvailable,
            listAvailable
          );
        }

        if (enough_information === true) {
          const itemResultKcal = $calculator.find(".calculator-results-title");
          const regimeType = $calculator.find(".calculator-results-content");

          const { croquetteWeight, humidWeight } =
            Calculator.calculateWeightsProportion(
              animalRegime,
              result,
              productDryCalories,
              productHumidCalories
            );

          const mainProductQtyNeedPerDay =
            productShape === "dry" ? croquetteWeight : humidWeight;
          const secondProductQtyNeedPerDay =
            productShape === "dry" ? humidWeight : croquetteWeight;

          let totalMainProductQtyNeedPerFrequency =
            mainProductQtyNeedPerDay * frequencyPurshase;
          let totalSecondProductQtyNeedPerFrequency =
            secondProductQtyNeedPerDay * frequencyPurshase;

          mainOptimalVariant =
            productShape === "dry"
              ? Calculator.findOptimalVariant(
                  mainProductVariants,
                  totalMainProductQtyNeedPerFrequency
                )
              : Calculator.findOptimalVariant(
                  secondProductVariants,
                  totalSecondProductQtyNeedPerFrequency
                );
          secondOptimalVariant =
            productShape === "dry"
              ? Calculator.findOptimalVariant(
                  secondProductVariants,
                  totalSecondProductQtyNeedPerFrequency
                )
              : Calculator.findOptimalVariant(
                  mainProductVariants,
                  totalMainProductQtyNeedPerFrequency
                );

          Calculator.updateCalculatorResults(
            $calculator,
            result,
            theme,
            regimeType,
            itemResultKcal,
            mainOptimalVariant,
            secondOptimalVariant,
            croquetteWeight,
            humidWeight,
            atcBiNutrition
          );
        }
      });
    });
  },
};

Calculator.init();
